<script lang="ts">
  import { goto } from '$app/navigation';
  import { page } from '$app/state';
  import Routes from '$provider/constants/Route';
  import Documents from './partial/Documents.svelte';
  import { URLSearchParamsKey } from '$provider/constants/URLSearchParamsKey';
  import type { CaqhDocument } from '$provider/models/profile/caqh/CaqhDocument';
  import type { CaqhDocumentInfo } from '$provider/models/profile/caqh/CaqhDocumentInfo';

  interface Props {
    documentInfo: CaqhDocumentInfo;
  }

  let { documentInfo }: Props = $props();

  const onClickFolderPath = (): void => {
    const providerId = page.params.provider;
    if (!providerId) return;

    const queryParam: string = `?${URLSearchParamsKey.Path}=${documentInfo.folderName}`;
    const route = `${Routes.ProviderDetailFile.replace('%providerId%', providerId)}${queryParam}`;
    goto(route);
  };

  const onClickFilePath = (doc: CaqhDocument): void => {
    const providerId = page.params.provider;
    if (!providerId) return;

    const queryParams = `?${URLSearchParamsKey.Path}=${documentInfo.folderName}&${URLSearchParamsKey.FileId}=${doc.download?.fileId}`;
    const route = `${Routes.ProviderDetailFile.replace('%providerId%', providerId)}${queryParams}`;
    goto(route);
  };
</script>

<div class="caqh-document-list-type">
  <div class="path-info">
    The following documents have been saved to <button
      class="highlight"
      onclick={onClickFolderPath}
    >
      {documentInfo?.documentPath}
    </button>
  </div>

  <Documents {documentInfo} onclick={onClickFilePath} />
</div>

<style>
  .caqh-document-list-type {
    margin-top: 12px;
  }
  .caqh-document-list-type .path-info {
    font-size: 11px;
    line-height: 18px;
    color: var(--grey-medium);
  }
  .caqh-document-list-type .path-info .highlight {
    color: blue;
    cursor: pointer;
  }
</style>
